export const colors = {
  // Primary Brand Colors
  deepTrustBlue: '#0052CC',
  honestTeal: '#00BFA6',
  deepBlue: '#003D99',

  // Background
  warmGray: '#F5F7FA',
  white: '#FFFFFF',

  // Text
  slateCharcoal: '#1F2933',
  steelGray: '#6B7280',

  // ReactBits-inspired text colors (softer white for dark mode)
  softWhite: '#E8E8E8',
  mutedWhite: '#D1D1D1',

  // Status Colors
  insightOrange: '#FF8C42',
  truthGreen: '#28A745',
  cautionRed: '#E63946',

  // Neutrals
  lightGray: '#E5E7EB',
  borderGray: '#D1D5DB',
  hintGray: '#9CA3AF',

  // ReactBits-inspired vibrant colors
  neonCyan: '#00d4ff',
  neonMagenta: '#ff00ff',
  neonViolet: '#7c3aed',
  neonPink: '#ff0099',
  darkBg: '#050510',
  darkSurface: 'rgba(255, 255, 255, 0.03)',

  // Gradients
  gradients: {
    trustBloom: 'linear-gradient(90deg, #0052CC 0%, #00BFA6 100%)',
    progressPop: 'linear-gradient(90deg, #00BFA6 0%, #FF8C42 100%)',
    darkOverlay: 'linear-gradient(135deg, rgba(0,82,204,0.95) 0%, rgba(0,191,166,0.85) 100%)',
    // ReactBits-inspired gradients
    neonGlow: 'linear-gradient(135deg, #00d4ff 0%, #ff00ff 50%, #7c3aed 100%)',
    cyanMagenta: 'linear-gradient(135deg, #00d4ff 0%, #ff00ff 100%)',
    vibrantPurple: 'linear-gradient(135deg, #7c3aed 0%, #4f46e5 100%)',
    sunsetOrange: 'linear-gradient(135deg, #f59e0b 0%, #ef4444 100%)',
  }
};
